import React from 'react';

// state
import { useAppSelector } from '../../../store/hooks';
import {} from '../../../service/api/report';

// components
import MiniButton from '../../../components/elements/forms/MiniButton';
import RichTextInputBox from '../../../components/elements/forms/RichTextInputBox';

type IUpdateReportLimitation = {
	onSubmit: (data: string) => void;
};

const UpdateReportLimitation: React.FC<IUpdateReportLimitation> = ({
	onSubmit
}) => {
	const [show, showSet] = React.useState<boolean>();
	const [data, dataSet] = React.useState<string>('');
	const report_stats = useAppSelector(({ report }) => report.report_stats);

	const onLoad = React.useCallback(() => {
		if (report_stats?.limitations) dataSet(report_stats?.limitations);
	}, [report_stats?.limitations]);

	React.useEffect(() => {
		onLoad();
	}, [onLoad]);

	return (
		<div>
			<div>
				{!show ? (
					report_stats?.limitations ? (
						<div
							dangerouslySetInnerHTML={{
								__html: report_stats.limitations
							}}
						/>
					) : (
						<div />
					)
				) : (
					<RichTextInputBox
						value={data}
						placeholder="Enter Limitation"
						status=""
						onChange={(e) => dataSet(e)}
					/>
				)}
			</div>
			<div>
				<div className="w-full flex justify-end my-2">
					<div className="w-[15%]">
						<MiniButton
							title={!show ? 'Edit' : 'Update'}
							onHandler={() => {
								if (show) {
									onSubmit(data);
									showSet(false);
								} else {
									showSet(true);
								}
							}}
							backgroundColor="#CDD8FE"
							textColor="#243677"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UpdateReportLimitation;
